import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
  tIndex: '首页',
  tNotification:'通知',
  tCarouselManagement:'轮播图管理',
  tCarouselDetail:'轮播图详情',
  tCarouselEdit:'轮播图编辑',
  tMemberManagement:'会员管理',
  tMemberList:'会员列表',
  tMemberDetail:'会员详情',
  tMemberAttendance:'打卡记录',
  tMemberComment:'评论记录',
  tMemberDiscuss:'会员talk记录',
  tMemberDisable:'已禁用会员',
  tMemberDel:'已注销会员',
  tDormant:'已休眠会员',
  tSend:'休眠通知记录',
  tReadManagement:'读书会管理',
  tReadList:'读书会列表',
  tReadDetail:'读书会详情',
  tReadUserList:'读书会参与列表',
  tEditRead:'读书会编辑',
  tReadNoticeList:'读书会公告列表',
  tEditReadNotice:'编辑读书会公告',
  tReadTaskList:'读书会任务列表',
  tEditReadTask:'编辑读书会任务',
  tReadCommentList:'读书会评论列表',
  tEditReadComment:'编辑读书会评论',
  tAttendanceList:'打卡列表',
  tComment:'评论列表',
  tReadTopicList:'读书会会员talk列表',
  tSerialManagement:'书籍管理',
  tSerialList:'书籍列表',
  tSerialDetail:'书籍详情',
  tEditSerial:'编辑书籍',
  tChapterList:'章节列表',
  tEditChapter:'编辑章节',
  tActivityManagement:'活动管理',
  tActivityList:'活动列表',
  tEditActivity:'编辑活动',
  tActivityDetail:'活动详情',
  tActivityUserList:'活动参与列表',
  tOrderManagement:'订单管理',
  tOrderList:'订单列表',
  tOrderDetail:'订单详情',
  tCouponManagement:'优惠券管理',
  tCouponList:'优惠券列表',
  tEditCoupon:'编辑优惠券',
  tCouponUseList:'优惠券使用列表',
  tServiceManagement:'服务管理',
  tServiceIntroduce:'服务介绍',
  tServiceCommentList:'评价列表',
  tEditComment:'编辑评价',
  tServiceCenter:'服务中心',
  tNotice:'公告列表',
  tEditNotice:'编辑公告',
  tFAQ:'常见疑问',
  tEditFAQ:'编辑常见问题',
  tQA:'问题与反馈',
  tEditQA:'回复问题与反馈',
  tQADetail:'问题与反馈详情',
  tSetting:'服务条款管理',
  tSettingList:'服务条款列表',
  tSettingEdit:'服务条款编辑',
  tAccountManagement:'账号管理',
  tIP:'IP管理',
  tLog:'日志管理',
  tEdit: '编辑',
  tDetail: '详情',
  notification:{
    sendNotification:'发送通知',
    send:'发送',
    title:'标题',
    msg:'内容',
    create_time:'创建时间'
  },
  carouselManagement:{
    title:'标题',
    create_time:'创建时间',
    update_time:'更新时间',
    image:'图片',
    h5_image:'手机端图片',
    order:'排序值',
    link:'跳转链接',
    h5_link:'h5跳转链接',
    active:'是否显示',
    active0:'不显示',
    active1:'显示',
    sureDeleteCarousel:'确认删除轮播图',
    urlRule:'链接必须以http或https开头'
  },
  accountManagement:{
      create_time:'创建时间',
      username:'用户名',
      password:'密码',
      auth:'权限等级',
      auth1:'超级管理员',
      auth2:'群组管理员',
      auth3:'活动管理员',
      auth4:'连载管理员',
      active:'是否激活',
      active0:'禁用',
      active1:'激活',
      superManagement:'超级管理员',
      normalManagement:'普通管理员',
      sureDeleteAccount:'确认删除管理员',
      menu:'权限'
  },
  memberManagement:{
      create_time:'创建时间',
      username:'用户名',
      real_name:'真实姓名',
      gender:'性别',
      gender0:'女',
      gender1:'男',
      gender2:'其他',
      phone:'联系方式',
      favorite_category:'喜欢的图书类别',
      favorite_category0:'文学',
      favorite_category1:'人文教育',
      favorite_category2:'历史',
      favorite_category3:'科学',
      favorite_category4:'儿童',
      favorite_category5:'青少年读物',
      favorite_category6:'绘本',
      favorite_category7:'英语',
      favorite_category8:'漫画',
      favorite_category9:'其他',
      is_library:'是否在图书馆工作',
      is_publish:'是否期望从事出版业',
      is_email:'是否同意接收邮件',
      is_sms:'是否同意接收SMS',
      active:'帐号状态',
      active0:'禁用',
      active1:'激活',
      yes:'是',
      no:'否',
      password:'密码',
      address:'地址',
      address_detail:'详细地址',
      birth:'生日',
      passwordRule:'请至少输入八位数，包含英文数字特殊符号',
      member_information:'会员基本信息',
      self_hobby:'个人喜好',
      project:'모임 이력',
      project0:'프롤로그',
      project1:'제1장',
      project2:'제2장',
      project3:'없음',
      more:'更多',
      login_time:'最后登录时间'
  },
  send:{
    create_time:'通知时间',
    to_email:'用户邮箱',
    real_name:'用户姓名'
  },
  serviceCommentList:{
    create_time:'创建时间',
    user_name:'评价人',
    service_name:'服务名称',
    active:'是否公开',
    active0:'不公开',
    active1:'公开',
    content1:'服务内容一',
    content2:'服务内容二',
    content3:'服务内容三',
    sureDeleteComment:'是否删除评论',
    is_bold0:'不加粗',
    is_bold1:'加粗',
  },
  readList:{
    time:'进行日期',
    create_time:'创建时间',
    update_time:'更新时间',
    apply:'已申请人数/总人数',
    apply_num:'当前申请数',
    type:'类型',
    type0:'创作与批评俱乐部',
    type1:'Book Club',
    title:'标题',
    subtitle:'副标题',
    content:'详情',
    cover:'封面',
    option:'选项',
    option_desc:'选项描述',
    other_title:'其他选项',
    other_content:'其他选项描述',
    price:'价格',
    total_num:'总人数',
    start_time:'开始时间',
    end_time:'结束时间',
    refund_desc:'退款说明',
    apply_time:'申请日期',
    apply_start:'申请开始时间',
    apply_end:'申请结束时间',
    search_tag:'搜索关键词',
    is_recommend:'是否推荐',
    is_recommend0:'不推荐',
    is_recommend1:'推荐',
    status:'状态',
    status0:'招募中',
    status1:'进行中',
    status2:'已结束',
    status3:'即将截止',
    status4:'未招募',
    status5:'未开始',
    toReadUseList:'查看用户参与列表',
    sureDeleteRead:'确认删除读书会',
    all:'全部',
    read_information:'读书会基本信息',
    read_setting:'读书会设置',
    more:'更多',
    toTask:'前往任务',
    toNotice:'前往公告',
    toTopic:'前往会员talk',
    toComment:'前往评论',
    read_calendar:'必读',
    read_task:'读书会介绍',
    challenge_rank:'任务介绍',
    challenge_guide:'活动方法',
    associated_club:'关联读书会'
  },
  readNoticeList:{
    create_time:'创建时间',
    publisher_name:'发布人',
    title:'标题',
    content:'内容',
    type:'类型',
    type0:'创作与批评俱乐部',
    type1:'Book Club',
    active:'状态',
    active0:'不公开',
    active1:'公开',
    order:'序号',
    sureDeleteNotice:'是否删除公告',
    is_top:'是否置顶',
    is_top1:'是',
    is_top0:'否',
  },
  readTaskList:{
    create_time:'创建时间',
    publisher_name:'发布人',
    title:'标题',
    content:'内容',
    end_time:'结束时间',
    type:'类型',
    type0:'创作与批评俱乐部',
    type1:'Book Club',
    active:'状态',
    active0:'不公开',
    active1:'公开',
    order:'序号',
    sureDeleteTask:'是否删除任务',
    toAttendanceList:'前往打卡列表',
  },
  readCommentList:{
    create_time:'创建时间',
    title:'标题',
    content:'内容',
    commentator:'评论人'
  },
  attendanceList:{
    username:'用户名',
    real_name:'真实姓名',
    task_title:'任务标题',
    title:'打卡标题',
    content:'打卡内容',
    attach:'附件',
    toCommentList:'前往评论列表'
  },
  readUserList:{
      create_time:'创建时间',
      username:'用户名',
      real_name:'真实姓名',
      phone_num:'电话号码',
      user_address:'地址',
      club_title:'读书会标题',
      status:'状态',
      status0:'审核中',
      status1:'已通过',
      status2:'已取消',
      status3:'待退款',
      status4:'已退款',
      refuse_reason:'拒绝理由',
      order_pay_amount:'实际支付金额',
      sureDeleteReadUser:'确认删除',
      changeStatus:'变更状态',
      cancel:'取消',
      allow:'通过',
      refund:'退款',
      all:'全部',
      group_leader:'组长帐号',
      gender:'性别',
      gender0:'女',
      gender1:'男',
      gender2:'其他',
      age:'出生年份',
      allow_print:'发放结业证'
  },
  readTopicList:{
    create_time:'创建时间',
    real_name:'真实姓名',
    avatar:'头像',
    content:'内容',
    delete:'状态',
    delete0:'未删除',
    delete1:'已删除',
    sureDeleteTopic:'确认删除会员talk',
    is_top:'是否置顶',
    is_top1:'是',
    is_top0:'否',
    top1:'置顶',
    top0:'取消置顶'
  },
  attendanceComment:{
    create_time:'创建时间',
    username:'用户名',
    real_name:'真实姓名',
    phone_num:'手机号',
    content:'内容',
    sureDeleteComment:'确认删除评论'
  },
  activityList:{
    time:'活动时间',
    create_time:'创建时间',
    update_time:'更新时间',
    apply_num:'当前申请人数',
    start_time:'活动开始时间',
    end_time:'活动结束时间',
    // apply_deadline:'申请活动截止时间',
    apply_time:'申请时间',
    apply_start:'申请开始时间',
    apply_end:'申请结束时间',
    title:'活动标题',
    content:'活动内容',
    cover:'活动图片',
    type:'活动类型',
    type1:'书评团',
    type2:'演讲',
    total_num:'可参与总人数',
    num:'已参与数/可参与总数',
    order:'排序值',
    sureDeleteActivity:'确认删除活动',
    status:'活动状态',
    status0:'모집 대기',
    status1:'募集中',
    status2:'即将截止',
    status3:'募集结束',
    toActivityUserList:'查看活动参与列表',
    active:'是否公开',
    active0:'不公开',
    active1:'公开',
    apply_type:'支付方式',
    apply_type0:'普通支付方式',
    apply_type1:'站外申请方式',
    external_link:'站外链接',
    is_pay:'是否付费',
    is_pay0:'否',
    is_pay1:'是',
    subtitle:'副标题',
    option:'选项',
    option_desc:'选项说明',
    price:'价格',
    refund_desc:'退款说明',
    is_deduction:'是否扣除',
    is_deduction0:'否',
    is_deduction1:'是',
    pay_type:'分类选项',
    pay_type0:'一般付费',
    pay_type1:'图书',
    pay_type2:'杂志',
    isbn_code:'ISBN',
    isbn_code0:'否',
    isbn_code1:'是',
    isbn_content:'ISBN'
  },
  activity_userList:{
    create_time:'创建时间',
    username:'用户名',
    real_name:'真实姓名',
    user_phone:'联系方式',
    user_address:'地址',
    address_detail:'详细地址',
    activity_title:'活动名称',
    activity_type:'活动类型',
    activity_type1:'书评团',
    activity_type2:'演讲',
    status:'状态',
    status0:'待审核',
    status1:'审核通过',
    status2:'已取消',
    status3:'待退款',
    status4:'已退款',
    s1:'通过申请',
    s2:'拒绝申请',
    s3:'同意退款',
    s4:'拒绝退款 ',
    sureDeleteUser:'确认删除',
    refuse_reason:'通过理由',
    changeStatus:'变更状态',
  },
  orderList:{
    status:'状态',
    status0:'未支付',
    status1:'已支付',
    status2:'支付失败',
    status3:'已退款',
    merchant_uid:'订单号',
    real_name:'真实姓名',
    title:'标题',
    type:'类型',
    club_type0:'创作与批评俱乐部',
    club_type1:'Book club',
    activity_type1:'Review group',
    activity_type2:'speech',
    pay_method:'支付方式',
    pay_method0:'card',
    pay_method1:'trans',
    pay_method2:'phone',
    pay_method3:'coupon',
    pay_method4:'naverpay',
    price:'原价',
    discount:'折扣价',
    pay_amount:'支付价',
    pay_time:'支付时间',
    username:'用户名',
    user_gender:'性别',
    user_gender0:'男',
    user_gender1:'女',
    user_gender2:'其他',
    user_phone:'手机号'
  },
  serialList:{
    update_time:'更新时间',
    title:'作品标题',
    detail:'作品详细介绍',
    cover:'作品封面图',
    book_desc:'作品简介',
    author_name:'作者名',
    author_desc:'作者介绍',
    day_of_week:'连载的星期',
    chapter_name:'最新章节名',
    author_img:'作者头像',
    is_recommend:'是否推荐',
    recommend0:'不推荐',
    recommend1:'推荐',
    is_switch_on:'是否置顶推荐',
    switch_on0:'不置顶',
    switch_on1:'置顶',
    status:'状态',
    status0:'连载中',
    status1:'已完结',
    active:'是否公开',
    active0:'不公开',
    active1:'公开',
    sureDeleteSerial:'确认删除书籍',
    serial_info:'书籍信息',
    author_info:'作者信息',
    serial_setting:'书籍设置',
    toChapterList:'点击查看连载章节列表',
    all:'全部',
    like_num:'点赞数量',
    link:'书店链接',
    tag:'标签'
  },
  chapterList:{
    create_time:'创建时间',
    update_time:'更新时间',
    title:'章节标题',
    number:'当前章节',
    content:'内容',
    active:'是否公开',
    active0:'不公开',
    active1:'公开',
    sureDeleteChapter:'确认删除章节',
    show_time:'定时发布',
    is_free:'非会员查看',
    is_free1:'是',
    is_free0:'否',
  },
  couponList:{
    type:'类型',
    type0:'创作者与批评俱乐部',
    type1:'Book Club',
    type2:'Review group',
    type3:'speech',
    time:'使用时间',
    create_time:'创建时间',
    update_time:'更新时间',
    start_time:'开始时间',
    end_time:'结束时间',
    redeem_code:'领取码',
    redeem_num:'当前已领取数量',
    title:'标题',
    totla_num:'可领取总数量',
    amount:'优惠金额',
    exchange:'已兑换数/可兑换总数',
    status:'状态',
    status0:'未开始',
    status1:'可使用',
    status2:'已过期',
    sureDeleteCoupon:'确认删除优惠券',
    user_name:'用户名',
    real_name:'真实姓名',
    user_phone:'联系方式',
    user_gender:'性别',
    user_gender0:'女',
    user_gender1:'男',
    service_info:'服务信息',
    use_time:'用户使用时间',
    toCouponUseList:'点击查看优惠券使用列表',
  },
  FAQ:{
    sureDeleteFAQ:'确认删除常见疑问',
    tag:'问题分类',
    order:'排序值',
    question:'问题',
    answer:'回答',
    active:'是否显示',
    active1:'显示',
    active0:'不显示'
  },
  QA:{
    create_time:'创建时间',
    update_time:'更新时间',
    title:'标题',
    question:'问题',
    status:'状态',
    status0:'未答复',
    status1:'已答复',
    answer:'回答',
    sureDeleteQA:'确认删除此反馈',
    username:'用户名',
    real_name:'真实姓名',
    category:'问题分类',
    category0:'创作与批评',
    category1:'bookclub',
    category2:'每日连载',
    category3:'活动',
    category4:'其他',
  },
  notice:{
    create_time:'创建时间',
    update_time:'更新时间',
    title:'标题',
    subtitle:'副标题',
    content:'内容',
    order:'排序值',
    active:'是否显示',
    active0:'不显示',
    active1:'显示',
    sureDeleteNotice:'确认删除公告',
    is_home:'是否推荐',
    is_home0:'不推荐',
    is_home1:'推荐',
    cover:'图片'
  },
  setting:{
    title:'标题'
  },
  memberAttendance:{
    club_title:'读书会标题',
    task_title:'任务标题',
    task_content:'任务内容',
    title:'打卡标题',
    content:'打卡内容',
    attach:'附件链接',
    file_name:'附件名称',
    create_time:'打卡时间'
  },
  memberComment:{
    club_title:'读书会标题',
    task_title:'任务标题',
    task_content:'任务内容',
    attendance_title:'打卡标题',
    attendance_content:'打卡内容',
    content:'评论内容',
    create_time:'评论时间'
  },
  memberDiscuss:{
    club_title:'读书会标题',
    content:'会员talk内容',
    create_time:'会员talk时间'
  },
  sureDelete:'确认删除?',
  day1:'星期一',
  day2:'星期二',
  day3:'星期三',
  day4:'星期四',
  day5:'星期五',
  select_date:'选择日期',
  please_select:'请选择',
  start_date:'开始日期',
  end_date:'结束日期',
  to:'至',
  search: '请输入关键字',
  exit: '退出',
  in:'进入',
  backstageName: 'switch_admin',
  loginSuccess:'登录成功',
  signOutSuccess:'退出成功',
  changeSuccess:'修改成功',
  inputAccount: '请输入帐号名',
  inputPassword: '请输入密码',
  min6:'长度不少于6个字符',
  min3:'长度不少于3个字符',
  operation: '操作',
  search_zh: '搜索',
  back: '返回',
  tips:'提示',
  outExe:'导出excel',
  sort:'排序',
  all:'全部',
  btnTip: {
    submit: '确认',
    check: '查看',
    edit: '编辑',
    delete: '删除',
    add: '添加',
    close: '关闭',
    cancel:'取消',
    resetPW: '重置密码',
    refuse:'拒绝',
    reset:'重置'
  }
}
export default {...zhLocale,...zh}




